import {
  Button,
  HStack,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Tab,
  TabList,
  Tabs,
} from '@chakra-ui/react';
import * as React from 'react';

import {
  BarChart2Icon,
  BookOpenIcon,
  ExternalLinkIcon,
  HelpCircleIcon,
  MessageSquareIcon,
} from '@/imports/ui/chakra/feather';
import { useIsMobile, useIsTablet } from '@/imports/ui/responsive/Responsive';

import { CreatePollModal } from './components/CreatePollModal';
import { CreatePostModal } from './components/CreatePostModal';
import { CreateQuestionModal } from './components/CreateQuestionModal';

export const PostingModal: React.FC<{
  isModalOpen: boolean;
  onModalClose: () => void;
  tabIndex: number;
  onTabChange: React.Dispatch<React.SetStateAction<number>>;
  createArticle: () => void;
  options?: {
    group?: { _id: string };
    organization?: { _id: string };
    defaultIsSponsoredPost?: boolean;
    tags?: { _id: string; name: string }[];
  };
}> = (props) => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  return (
    <Modal
      isOpen={props.isModalOpen}
      onClose={props.onModalClose}
      size="xl"
      closeOnOverlayClick={false}
      closeOnEsc={false}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          bg="gray.50"
          px="6"
          py="0"
          borderBottom="1px"
          borderBottomColor="gray.100"
          borderTopRadius="md"
        >
          <Tabs
            index={props.tabIndex}
            onChange={props.onTabChange}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            isManual={true} // Allows `Form Title` to be focused when a tab is selected
          >
            <TabList>
              <Tab px="2">
                <MessageSquareIcon mr="2" />
                Message
              </Tab>
              <Tab px="2">
                <HelpCircleIcon mr="2" />
                Question
              </Tab>
              <Tab px="2">
                <BarChart2Icon mr="2" transform="rotate(90deg)" />
                Poll
              </Tab>
            </TabList>
            <HStack>
              <Button
                variant="outline"
                colorScheme="gray"
                background="gray.50"
                fontWeight="normal"
                onClick={props.createArticle}
                leftIcon={<BookOpenIcon color="gray.400" />}
                rightIcon={<ExternalLinkIcon />}
              >
                Article
              </Button>
            </HStack>
            {!isMobile && !isTablet && <ModalCloseButton position="static" />}
          </Tabs>
        </ModalHeader>
        {props.tabIndex === 0 && (
          <CreatePostModal
            onClose={props.onModalClose}
            createArticle={props.createArticle}
            group={props.options?.group}
            organization={props.options?.organization}
            defaultIsSponsoredPost={props.options?.defaultIsSponsoredPost}
            tags={props.options?.tags}
          />
        )}
        {props.tabIndex === 1 && (
          <CreateQuestionModal
            onClose={props.onModalClose}
            group={props.options?.group}
            organization={props.options?.organization}
            defaultIsSponsoredPost={props.options?.defaultIsSponsoredPost}
            tags={props.options?.tags}
          />
        )}
        {props.tabIndex === 2 && (
          <CreatePollModal
            onClose={props.onModalClose}
            group={props.options?.group}
            organization={props.options?.organization}
            defaultIsSponsoredPost={props.options?.defaultIsSponsoredPost}
            tags={props.options?.tags}
          />
        )}
      </ModalContent>
    </Modal>
  );
};
